const apiVersion = 'v1';

import {
  IVAV,
  IAHU,
} from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

const getVAVLatestReadingsById = async (
  vavId: number,
  options: { signal?: AbortSignal } = {}
): Promise<IVAV> => {
  try {
    const { signal } = options;

    const response = await window.axios.get(
      `/${apiVersion}/VariableAirVolumeUnits/${vavId}/latest-readings`,
      { signal }
    );

    const { data } = response.data;
    return data as IVAV;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getVAVById = async (
  vavId: number,
  options: { signal?: AbortSignal } = {}
): Promise<IVAV> => {
  try {
    const { signal } = options;

    const response = await window.axios.get(
      `/${apiVersion}/VariableAirVolumeUnits/${vavId}`,
      { signal }
    );

    const { data } = response.data;
    return data as IVAV;
  } catch (err) {
    return Promise.reject(err);
  }
};

const setVAVSetpoint = async (
  vavId: number,
  setpoints: Partial<IVAV>
): Promise<void> => {
  try {
    await window.axios.put(
      `/${apiVersion}/VariableAirVolumeUnits/${vavId}/settings`,
      {
        changedSettings: {
          occupiedSetpoint: setpoints.occupiedSetpoint,
          maxOccupiedSetpoint: setpoints.maxOccupiedSetpoint,
          minOccupiedSetpoint: setpoints.minOccupiedSetpoint,
          heatingSignal: setpoints.heatingSignal,
          coolingSignal: setpoints.coolingSignal,
          desiredAirflow: setpoints.desiredAirflow,
        },
      }
    );
  } catch (err) {
    return Promise.reject(err);
  }
};

const getAHUById = async (ahuId: number): Promise<IAHU> => {
  try {
    const response = await window.axios.get(
      `/${apiVersion}/AirHandlerUnits/${ahuId}/latest-readings`
    );

    const { data } = response.data;

    return data as IAHU;
  } catch (err) {
    return Promise.reject(err);
  }
};

const setAHUSetpoint = async (
  ahuId: number,
  setpoints: Partial<IAHU>
): Promise<void> => {
  try {
    await window.axios.put(`/${apiVersion}/AirHandlerUnits/${ahuId}/settings`, {
      changedSettings: {
        netSupplyAirCoolingSetpoint: setpoints.netSupplyAirCoolingSetpoint,
        minSupplyAirCoolingSetpoint: setpoints.minSupplyAirCoolingSetpoint,
        ductStaticPressureSetpoint: setpoints.ductStaticPressureSetpoint,
      },
    });
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  getVAVLatestReadingsById,
  getVAVById,
  setVAVSetpoint,
  getAHUById,
  setAHUSetpoint,
};
